export default __webpack_public_path__ + "gravity-affixc32d91.gif";